import React from 'react';
import { Link } from 'react-router';
import { DeleteDialog } from 'modules/dialog';
import moment from 'moment';
import { get } from 'lodash';

class RowItemDanhSachKeHoachThanhTra extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <Link className='txt-underline txt-regular' to={`/thanh-tra/chi-tiet-ke-hoach/${get(this.props.item, 'keHoachThanhTraId')}`}>{`Kế hoạch ${this.props.item.loaiKeHoach.value === 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra'} năm ${get(this.props.item, 'namThanhTra')} ${this.props.item && this.props.item.keHoacThanhTraCuInfo ? '(sửa đổi, bổ sung lần 1)' : ''}`}</Link>
        </td>
        <td className='list-items-table'>{get(this.props.item, 'quyetDinhPheDuyetKTTT')}</td>
        <td>{this.props.item.ngayRaQuyetDinh ? moment(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}</td>
        <td>{get(this.props.item, 'soCuocThanhTra')}</td>
        <td>{get(this.props.item, 'trangThaiKeHoachThanhTraInfo.text')}</td>
        <td>
          {!this.props.item.daCoKeHoachBoSung && this.props.item.choPhepChinhSua &&
            <div className="todo-wrap two-item">
              {/* chờ PM hỏi lại login
              {(this.props.item.activeTaoCuocThanhTra && !this.props.item.keHoacThanhTraCuInfo) &&
                <div className="wrap-link-todo">
                  <Link className="itt-add" to={`/thanh-tra/them-moi-ke-hoach-bo-sung/${this.props.item.keHoachThanhTraId}`}>Sửa đổi, bổ sung</Link>
                </div>
              } */}
              {(get(this.props.item, 'trangThaiKeHoachThanhTra') === 'DA_CO_QUYET_DINH') &&
                <div className="wrap-link-todo">
                  <Link className="itt-edit" to={{ pathname: `/thanh-tra/dieu-chinh-ke-hoach-da-phe-duyet/${this.props.item.keHoachThanhTraId}`, state: { data: this.props.item, keHoachDaCoQuyetDinh: true } }}>Điều chỉnh</Link>
                </div>
              }
              {(get(this.props.item, 'trangThaiKeHoachThanhTra') === "DANG_SOAN" || get(this.props.item, 'trangThaiKeHoachThanhTra') === "CHO_RA_QUYET_DINH") &&
                <div className="wrap-link-todo">
                  <Link className="itt-edit" to={{ pathname: `/thanh-tra/chinh-sua-ke-hoach/${this.props.item.keHoachThanhTraId}`, state: { keHoachDaCoQuyetDinh: false } }}>Chỉnh sửa</Link>
                </div>
              }
              {(get(this.props.item, 'trangThaiKeHoachThanhTra') === "DANG_SOAN") &&
                <DeleteDialog
                  title={'Xác nhận'}
                  content={`Bạn có đồng ý xóa kế hoạch này không?`}
                  redux={this.props.parent}
                  deleteId={this.props.item.keHoachThanhTraId}
                />
              }
            </div>
          }
        </td>
      </tr>
    );
  }
}


export default RowItemDanhSachKeHoachThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemDanhSachKeHoachThanhTra.jsx